<template>
    <span>
        <!-- BEGIN PRODUCT INFO FOR {{ product.name }} -->

        <div class="product_info col-lg-3 col-md-3 col-xs-6 text-center" itemscope itemtype="http://schema.org/Product">
            <router-link :to="{name: 'product-detail', params: { productSlug: product.slug } }" :title="product.name" v-canvas="'/storage/products/' + product.photo">

            </router-link>

            <span itemprop="description" class="hidden">
                {{product.description}}
            </span>
            <h2 class="product-name" itemprop="name">{{ product.name }}</h2>

            <form role="form" class="form form-inline child-selection">
                <select v-model="selectedChild" v-if="hasChildren" class="form-control" name="children">
                    <option :value="child.id" v-for="child in product.children" :selected="(child.selected === 1) ? selected : null">
                        {{child.name}} | £{{child.price}}
                    </option>
                </select>
                <span v-else>
                    <strong>{{product.name}} at £{{product.price}}</strong>
                </span>
                <input v-model="quantity" type="number" class="form-control" name="quantity">
                <button class="btn btn-primary" @click.prevent="addToCart">
                    <i class="fa fa-plus"></i> | Add to cart
                </button>
            </form>
        </div>
    </span>
</template>
<script>

    import { find } from 'lodash';

    export default {

        data() {
            return {
                selectedChild: 0,
                quantity: 1
            }
        },

        created() {
            if (this.hasChildren) {
                this.selectedChild = this.product.children[ 0 ].id;
            } else {
                this.selectedChild = this.product.id;
            }
        },

        props: ['product'],

        methods: {
            showSupplierOrder() {
                return (product.children.length === 0 && product.suppliers.length > 0);
            },

            trimDescription( description, trimTo ) {
                if ( description ) {
                    return description.length > trimTo ? description.substring( 0, trimTo - 3 ) + "..." : description;
                } else {
                    return "";
                }
            },

            addButton( button, data = null) {
                if (!data) {
                    button.className += " disabled";
                    button.innerHTML = '<i class="fa fa-spin fa-spinner"></i> Adding';
                } else {
                    if (data.error) {
                        button.className = 'btn btn-danger'

                    } else {
                        button.className = button.className.replace( new RegExp( '(?:^|\\s)' + 'disabled' + '(?:\\s|$)' ), ' ' );
                    }
                    button.innerHTML = data.text;
                }
            },

            addToCart() {
                let button = event.currentTarget;
                let item = {};
                this.addButton(button);
                this.$store.dispatch( 'addItemToCart', this.item ).then(
                    ( cart ) => {
                        this.addButton( button, {text: '<i class="fa fa-plus"></i> | Add to cart'} )
                    },
                    ( error ) => {
                        this.addButton( button, {text: 'Error adding item', error: error} );
                    }
                );
            }
        },

        computed: {
            item() {
                return {
                    product_id: this.itemProduct,
                    quantity: this.quantity,
                    cost: this.cost
                }
            },

            itemProduct() {
                return (this.hasChildren) ? this.selectedChild : this.product.id;
            },

            cost() {
                let product = ( this.hasChildren ) ? find( this.product.children, {id: this.itemProduct} ) : this.product;
                return product.price;
            },

            hasChildren() {
                return (this.product.children.length > 0);
            }
        },

        filters: {

        }
    }
</script>
